import { Text } from '@/components/atoms/Text';

const PricingSectionHeaderColumnSecondaryText = ({
  text,
}: {
  text: string;
}) => {
  return (
    <Text variant='body-s' classNames={{ wrapper: 'text-gray-500' }}>
      {text}
    </Text>
  );
};

export default PricingSectionHeaderColumnSecondaryText;
